export enum AccountRole {
  VENDOR = 'VENDOR',
  HOTEL = 'HOTEL',
  ADMIN = 'ADMIN',
  VAULTONLY = 'VAULTONLY'
}
